<app-header></app-header>
<main class="main-content">
  <!------main-content------>
  <!-----------page_title--------------->

  <!-----------page_title-end-------------->
  <!-----------footer--------------->
  <section class="contact_page pdb_70 pspan_100">
    <div class="container">
      <div class="row">
        <!---------row----------->
        <div class="col-lg-12 col-md-12">
          <!---------col----------->

          <div class="contact_us_form ml-5 mr-5 mt-5">
            <div class="heading tp_one pt-5">
              <h6>Register with Us</h6>
              <h1>Registration (Departing From Equatorial Guinea)</h1>
              <p class="pt-0">
                Lorem Ipsum is simply dummy text of the printing and typesetting
                industry.
              </p>
            </div>

            <div class="row">
              <div class="col-12">
                <ul class="steps">
                  <li
                    [ngClass]="{ 'dashboard-steps-active': personalInfoTab }"
                    (click)="showPersonalInfo()"
                  >
                    <i class="fas fa-user-edit"></i> Personal Information
                  </li>
                  <li
                    [ngClass]="{ 'dashboard-steps-active': bookAppointmentTab }"
                    (click)="backBookAppointment()"
                  >
                    <i class="far fa-calendar-check"></i> Book Appointment for
                    COVID-19 Test
                  </li>
                  <li
                    [ngClass]="{ 'dashboard-steps-active': confirmationTab }"
                    (click)="showConfirmation()"
                  >
                    <i class="far fa-check-circle"></i> Confirmation
                  </li>
                  <li
                    [ngClass]="{ 'dashboard-steps-active': paymentTab }"
                    (click)="showPayment()"
                  >
                    <i class="far fa-credit-card"></i> Pay
                  </li>
                </ul>
              </div>

              <div class="col-lg-12 inbound-regi" *ngIf="personalInfoTab">
                <h3 class="dashboard-heading-1 mt-4 mb-4">
                  Passenger personal Information
                </h3>
                <form
                  [formGroup]="registerForm"
                  (ngSubmit)="onSubmitPersonalInfo(registerForm.value)"
                >
                  <div class="row mb-3">
                    <div class="col-md-4 mt-2">
                      <label class="form-label"
                        >Passport Number<sup
                          class="ml-1 font-weight-bolder text-danger"
                          >*</sup
                        ></label
                      >
                      <input
                        type="text"
                        class="form-control"
                        (change)="getPassportDetails($event)"
                        id="passportNumber"
                        maxlength="15"
                        formControlName="passportNumber"
                        [ngClass]="{ 'is-invalid': submitted &amp;&amp; registerForm.controls.passportNumber.errors }"
                        placeholder="Passport Number"
                      />
                      <div
                        *ngIf="submitted &amp;&amp; registerForm.controls.passportNumber.errors"
                        class="form-text text-danger"
                      >
                        <div
                          *ngIf="
                            registerForm.controls.passportNumber.errors.required
                          "
                        >
                          Passport number is required
                        </div>
                        <div
                          *ngIf="
                            registerForm.controls.passportNumber.errors.pattern
                          "
                        >
                          Must be alphabets or numeric characters
                        </div>
                        <div
                          *ngIf="
                            registerForm.controls.passportNumber.errors
                              .minlength
                          "
                        >
                          Please enter a valid Passport number
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-4">
                      <label class="form-label"
                        >First Name<sup
                          class="ml-1 font-weight-bolder text-danger"
                          >*</sup
                        ></label
                      >

                      <input
                        type="text"
                        class="form-control"
                        maxlength="20"
                        id="firstName"
                        formControlName="firstName"
                        placeholder="First name"
                        [ngClass]="{ 'is-invalid': submitted &amp;&amp; registerForm.controls.firstName.errors }"
                      />

                      <div
                        *ngIf="submitted &amp;&amp; registerForm.controls.firstName.errors"
                        class="form-text text-danger"
                      >
                        <div
                          *ngIf="
                            registerForm.controls.firstName.errors.required
                          "
                        >
                          First name is required
                        </div>
                        <div
                          *ngIf="
                            registerForm.controls.firstName.errors.maxlength
                          "
                        >
                          First name must be under 45 characters
                        </div>
                        <div
                          *ngIf="registerForm.controls.firstName.errors.pattern"
                        >
                          First name must be only alphabets
                        </div>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <label class="form-label">Middle Name</label>
                      <input
                        type="text"
                        class="form-control"
                        maxlength="20"
                        id="middleName"
                        formControlName="middleName"
                        placeholder="Middle name"
                        [ngClass]="{ 'is-invalid': submitted &amp;&amp; registerForm.controls.middleName.errors }"
                      />
                      <div
                        *ngIf="submitted &amp;&amp; registerForm.controls.middleName.errors"
                        class="form-text text-danger"
                      >
                        <!-- <div *ngIf="registerForm.controls.middleName.errors.required">Middle name is required</div>  -->
                        <div
                          *ngIf="
                            registerForm.controls.middleName.errors.maxlength
                          "
                        >
                          Middle name must be under 45 characters
                        </div>
                        <div
                          *ngIf="
                            registerForm.controls.middleName.errors.pattern
                          "
                        >
                          Middle name must be only alphabets
                        </div>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <label class="form-label"
                        >Last Name<sup
                          class="ml-1 font-weight-bolder text-danger"
                          >*</sup
                        ></label
                      >
                      <input
                        type="text"
                        class="form-control"
                        maxlength="20"
                        formControlName="lastName"
                        placeholder="Last name"
                        [ngClass]="{ 'is-invalid': submitted &amp;&amp; registerForm.controls.lastName.errors }"
                      />
                      <div
                        *ngIf="submitted &amp;&amp; registerForm.controls.lastName.errors"
                        class="form-text text-danger"
                      >
                        <div
                          *ngIf="registerForm.controls.lastName.errors.required"
                        >
                          Last name is required
                        </div>
                        <div
                          *ngIf="
                            registerForm.controls.lastName.errors.maxlength
                          "
                        >
                          Last name must be under 45 characters
                        </div>
                        <div
                          *ngIf="registerForm.controls.lastName.errors.pattern"
                        >
                          Last name must be only alphabets
                        </div>
                      </div>
                    </div>

                    <div class="form-group col-md-4 mt-2">
                      <label for="inputState"
                        >Gender<sup class="ml-1 font-weight-bolder text-danger"
                          >*</sup
                        ></label
                      >
                      <select
                        id="inputState"
                        class="form-control"
                        formControlName="gender"
                        placeholder=""
                        [ngClass]="{ 'is-invalid': submitted &amp;&amp; registerForm.controls.gender.errors }"
                      >
                        <option value="">Select Gender</option>
                        <option selected="" value="MALE">Male</option>
                        <option value="FEMALE">Female</option>
                      </select>
                      <div
                        *ngIf="submitted &amp;&amp; registerForm.controls.gender.errors"
                        class="form-text text-danger"
                      >
                        <div
                          *ngIf="registerForm.controls.gender.errors.required"
                        >
                          Gender is required
                        </div>
                      </div>
                    </div>

                    <div class="col-md-4 mt-2">
                      <label class="form-label"
                        >Date Of Birth<sup
                          class="ml-1 font-weight-bolder text-danger"
                          >*</sup
                        ></label
                      >
                      <input
                        type="date"
                        class="form-control"
                        max="{{ date | date: 'yyyy-MM-dd' }}"
                        formControlName="dateOfBirth"
                        placeholder=""
                        [ngClass]="{ 'is-invalid': submitted &amp;&amp; registerForm.controls.dateOfBirth.errors }"
                      />
                      <div
                        *ngIf="submitted &amp;&amp; registerForm.controls.dateOfBirth.errors"
                        class="form-text text-danger"
                      >
                        <div
                          *ngIf="
                            registerForm.controls.dateOfBirth.errors.required
                          "
                        >
                          Date of birth is required
                        </div>
                      </div>
                    </div>
                    <div class="col-md-4 mt-2">
                      <label class="form-label"
                        >Residential Address<sup
                          class="ml-1 font-weight-bolder text-danger"
                          >*</sup
                        ></label
                      >
                      <input
                        type="text"
                        class="form-control"
                        maxlength="40"
                        formControlName="currentAddress"
                        placeholder="Residential Address"
                        [ngClass]="{ 'is-invalid': submitted &amp;&amp; registerForm.controls.currentAddress.errors }"
                      />
                      <div
                        *ngIf="submitted &amp;&amp; registerForm.controls.currentAddress.errors"
                        class="form-text text-danger"
                      >
                        <div
                          *ngIf="
                            registerForm.controls.currentAddress.errors.required
                          "
                        >
                          Residential address is required
                        </div>
                        <div
                          *ngIf="
                            registerForm.controls.currentAddress.errors.pattern
                          "
                        >
                          Can only contain alphnumeric characters
                        </div>
                        <div
                          *ngIf="
                            registerForm.controls.currentAddress.errors
                              .maxlength
                          "
                        >
                          Residential address must be under 60 characters
                        </div>
                      </div>
                    </div>

                    <div class="form-group col-md-4">
                      <label for="inputState"
                        >Nationality<sup
                          class="ml-1 font-weight-bolder text-danger"
                          >*</sup
                        ></label
                      >
                      <!-- <select id="inputState" class="form-control" formControlName="nationality"  placeholder=""
                                    [ngClass]="{ 'is-invalid': submitted &amp;&amp; registerForm.controls.nationality.errors }">
                                       <option value="">Select Nationality</option>
                                       <option selected="">Nigeria</option>
                                       <option>India </option>
                                       <option>United Kingdom </option>
                                    </select> -->
                      <!-- <input id="inputState" class="form-control" maxlength="30" formControlName="nationality" placeholder="Nationality"
                        [ngClass]="{ 'is-invalid': submitted &amp;&amp; registerForm.controls.nationality.errors }"> -->

                      <select
                        id="nationality"
                        class="form-control"
                        formControlName="nationality"
                        [ngClass]="{ 'is-invalid': submitted &amp;&amp; registerForm.controls.nationality.errors }"
                      >
                        <option selected value="">Select Nationality</option>
                        <option
                          *ngFor="let country of shared.countries"
                          value="{{ country.name }}"
                        >
                          {{ country.name }}
                        </option>
                      </select>

                      <div
                        *ngIf="submitted &amp;&amp; registerForm.controls.nationality.errors"
                        class="form-text text-danger"
                      >
                        <div
                          *ngIf="
                            registerForm.controls.nationality.errors.required
                          "
                        >
                          Nationality is required
                        </div>
                        <div
                          *ngIf="
                            registerForm.controls.nationality.errors.pattern
                          "
                        >
                          Must be only alphabets
                        </div>
                      </div>
                    </div>

                    <div class="col-md-4">
                      <label class="form-label"
                        >Country of Residence<sup
                          class="ml-1 font-weight-bolder text-danger"
                          >*</sup
                        ></label
                      >

                      <!-- <input type="text" class="form-control" maxlength="30" formControlName="countryOfResidence" placeholder="Country of Residence"
                                       [ngClass]="{ 'is-invalid': submitted &amp;&amp; registerForm.controls.countryOfResidence.errors }"> -->

                      <select
                        id="countryOfResidence"
                        class="form-control"
                        formControlName="countryOfResidence"
                        [ngClass]="{ 'is-invalid': submitted &amp;&amp; registerForm.controls.countryOfResidence.errors }"
                      >
                        <option selected value="">
                          Select Country of Residence
                        </option>
                        <option
                          *ngFor="let country of shared.countries"
                          value="{{ country.name }}"
                        >
                          {{ country.name }}
                        </option>
                      </select>

                      <div
                        *ngIf="submitted &amp;&amp; registerForm.controls.countryOfResidence.errors"
                        class="form-text text-danger"
                      >
                        <div
                          *ngIf="
                            registerForm.controls.countryOfResidence.errors
                              .required
                          "
                        >
                          Country of residence is required
                        </div>
                        <div
                          *ngIf="
                            registerForm.controls.countryOfResidence.errors
                              .pattern
                          "
                        >
                          Must be only alphabets
                        </div>
                      </div>
                    </div>

                    <div class="col-md-4">
                      <label class="form-label"
                        >Email Address<sup
                          class="ml-1 font-weight-bolder text-danger"
                          >*</sup
                        ></label
                      >
                      <input
                        type="email"
                        class="form-control"
                        maxlength="35"
                        formControlName="emailAddress"
                        id="emailAddress"
                        aria-describedby="emailHelp"
                        [ngClass]="{ 'is-invalid': submitted &amp;&amp; registerForm.controls.emailAddress.errors }"
                        placeholder="Email Address"
                      />
                      <div
                        *ngIf="submitted &amp;&amp; registerForm.controls.emailAddress.errors"
                        class="form-text text-danger"
                      >
                        <div
                          *ngIf="
                            registerForm.controls.emailAddress.errors.required
                          "
                        >
                          Email is required
                        </div>
                        <div
                          *ngIf="
                            registerForm.controls.emailAddress.errors.email
                          "
                        >
                          Please enter a valid email
                        </div>
                        <div
                          *ngIf="
                            registerForm.controls.emailAddress.errors.maxlength
                          "
                        >
                          Email must be under 45 characters
                        </div>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <label class="form-label"
                        >Confirm Email Address<sup
                          class="ml-1 font-weight-bolder text-danger"
                          >*
                        </sup>
                      </label>
                      <input
                        type="email"
                        maxlength="35"
                        class="form-control"
                        formControlName="confirmEmailAddress"
                        id="confirmEmailAddress"
                        aria-describedby="emailHelp"
                        [ngClass]="{ 'is-invalid': submitted &amp;&amp; registerForm.controls.confirmEmailAddress.errors }"
                        placeholder="Confirm Email Address"
                      />
                      <small class="ml-2"
                        ><img src="assets/image/info.png" /> QR Code will be
                        sent there</small
                      >
                      <div
                        *ngIf="submitted &amp;&amp; registerForm.controls.confirmEmailAddress.errors"
                        class="form-text text-danger"
                      >
                        <div
                          *ngIf="
                            registerForm.controls.confirmEmailAddress.errors
                              .required
                          "
                        >
                          Confirm email is required
                        </div>
                        <div
                          *ngIf="
                            registerForm.controls.confirmEmailAddress.errors
                              .email
                          "
                        >
                          Please enter a valid email
                        </div>
                        <div
                          *ngIf="
                            registerForm.controls.confirmEmailAddress.errors
                              .maxlength
                          "
                        >
                          Email must be under 45 characters
                        </div>
                        <div
                          *ngIf="
                            registerForm.controls.confirmEmailAddress.errors
                              .mustMatch
                          "
                        >
                          Confirm email must match
                        </div>
                      </div>
                    </div>

                    <div class="col-md-4">
                      <label class="form-label"
                        >Phone Number<sup
                          class="ml-1 font-weight-bolder text-danger"
                          >*</sup
                        ></label
                      >
                      <input
                        type="text"
                        class="form-control"
                        id="phone"
                        maxlength="13"
                        formControlName="phone"
                        [ngClass]="{ 'is-invalid': submitted &amp;&amp; registerForm.controls.phone.errors }"
                        placeholder="Phone Number"
                      />
                      <div
                        *ngIf="submitted &amp;&amp; registerForm.controls.phone.errors"
                        class="form-text text-danger"
                      >
                        <div
                          *ngIf="registerForm.controls.phone.errors.required"
                        >
                          Phone number is required
                        </div>
                        <div *ngIf="registerForm.controls.phone.errors.pattern">
                          Please enter a valid Phone number
                        </div>
                        <div
                          *ngIf="registerForm.controls.phone.errors.minlength"
                        >
                          Minimum of 9 digits required
                        </div>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <label class="form-label"
                        >Occupation<sup
                          class="ml-1 font-weight-bolder text-danger"
                          >*</sup
                        ></label
                      >
                      <input
                        type="text"
                        class="form-control"
                        maxlength="30"
                        formControlName="occupation"
                        placeholder="Occupation"
                        [ngClass]="{ 'is-invalid': submitted &amp;&amp; registerForm.controls.occupation.errors }"
                      />
                      <div
                        *ngIf="submitted &amp;&amp; registerForm.controls.occupation.errors"
                        class="form-text text-danger"
                      >
                        <div
                          *ngIf="
                            registerForm.controls.occupation.errors.pattern
                          "
                        >
                          Must be only alphabets
                        </div>
                        <div
                          *ngIf="
                            registerForm.controls.occupation.errors.required
                          "
                        >
                          Occupation is required
                        </div>
                        <div
                          *ngIf="
                            registerForm.controls.occupation.errors.maxlength
                          "
                        >
                          Occupation must be under 45 characters
                        </div>
                      </div>
                    </div>

                    <div class="seprator-1"></div>

                    <div class="col-lg-12">
                      <h3 class="dashboard-heading-1 minus-top-2">
                        Passenger Traveling Information
                      </h3>
                    </div>

                    <div class="form-group col-md-4 mt-2">
                      <label for="inputState"
                        >Country To Be Visited<sup
                          class="ml-1 font-weight-bolder text-danger"
                          >*</sup
                        ></label
                      >
                      <!-- <input class="form-control" id="travelLocation" formControlName="travelLocation"  maxlength="30"
                                    [ngClass]="{ 'is-invalid': submitted &amp;&amp; registerForm.controls.travelLocation.errors }" placeholder="Country to be Visited"> -->

                      <select
                        id="travelLocation"
                        class="form-control"
                        formControlName="travelLocation"
                        [ngClass]="{ 'is-invalid': submitted &amp;&amp; registerForm.controls.travelLocation.errors }"
                      >
                        <option selected value="">
                          Select Country To Be Visited
                        </option>
                        <option
                          *ngFor="let country of shared.countries"
                          value="{{ country.name }}"
                        >
                          {{ country.name }}
                        </option>
                      </select>

                      <div
                        *ngIf="submitted &amp;&amp; registerForm.controls.travelLocation.errors"
                        class="form-text text-danger"
                      >
                        <div
                          *ngIf="
                            registerForm.controls.travelLocation.errors.required
                          "
                        >
                          Travel location is required
                        </div>
                        <div
                          *ngIf="
                            registerForm.controls.travelLocation.errors.pattern
                          "
                        >
                          Must be only alphabets
                        </div>
                      </div>
                    </div>

                    <div class="form-group col-md-4 mt-2">
                      <label for="inputState"
                        >Select Airline<sup
                          class="ml-1 font-weight-bolder text-danger"
                          >*</sup
                        ></label
                      >
                      <select
                        class="form-control"
                        formControlName="airline"
                        placeholder=""
                        [ngClass]="{ 'is-invalid': submitted &amp;&amp; registerForm.controls.airline.errors }"
                      >
                        <option selected value="">Select Airline</option>
                        <option
                          *ngFor="let airline of airlines"
                          value="{{ airline.id }}"
                        >
                          {{ airline.name }}
                        </option>
                      </select>
                      <div
                        *ngIf="submitted &amp;&amp; registerForm.controls.airline.errors"
                        class="form-text text-danger"
                      >
                        <div
                          *ngIf="registerForm.controls.airline.errors.required"
                        >
                          Airline is required
                        </div>
                      </div>
                    </div>

                    <div class="col-md-4 mt-2">
                      <label class="form-label"
                        >Expected Travel Date<sup
                          class="ml-1 font-weight-bolder text-danger"
                          >*</sup
                        ></label
                      >
                      <input
                        type="date"
                        class="form-control"
                        (change)="changeTravelDate($event.target.value)"
                        min="{{ date | date: 'yyyy-MM-dd' }}"
                        formControlName="travelDate"
                        placeholder=""
                        [ngClass]="{ 'is-invalid': submitted &amp;&amp; registerForm.controls.travelDate.errors }"
                      />
                      <div
                        *ngIf="submitted &amp;&amp; registerForm.controls.travelDate.errors"
                        class="form-text text-danger"
                      >
                        <div
                          *ngIf="
                            registerForm.controls.travelDate.errors.required
                          "
                        >
                          Travel date is required
                        </div>
                      </div>
                    </div>
                    <!-- [ngClass]="{ 'd-none': travelDateStatus == false }" -->
                    <div
                      class="col-md-4 mt-2"
                    >
                      <label class="form-label"
                        >Expected Return Date
                        <!-- <sup class="ml-1 font-weight-bolder text-danger"
                          >*</sup> -->
                          </label
                      >
                      <input
                        type="date"
                        class="form-control"
                        min="{{ travelDate | date: 'yyyy-MM-dd' }}"
                        formControlName="returnDate"
                        placeholder=""
                        [ngClass]="{ 'is-invalid': submitted &amp;&amp; registerForm.controls.returnDate.errors }"
                      />
                      <div
                        *ngIf="submitted &amp;&amp; registerForm.controls.returnDate.errors"
                        class="form-text text-danger"
                      >
                        <div
                          *ngIf="
                            registerForm.controls.returnDate.errors.required
                          "
                        >
                          Return date is required
                        </div>
                      </div>
                    </div>

                    <div class="col-md-12 mt-2 text-center mb-3 mt-5">
                      <button
                        type="submit"
                        class="btn btn-primary theme-btn ml-3"
                      >
                        Next <i class="fas fa-angle-double-right"></i>
                      </button>
                    </div>
                  </div>
                </form>
              </div>

              <div class="col-lg-12 inbound-regi" *ngIf="bookAppointmentTab">
                <form
                  [formGroup]="appointmentForm"
                  (ngSubmit)="onSubmitAppointment(appointmentForm.value)"
                >
                  <div class="row">
                    <div class="col-lg-5 col-md-6 mt-5 border-right col-sm-12">
                      <h3 class="dashboard-heading-1 mb-3">Book Appointment</h3>

                      <div class="col-md-12">
                        <label class="form-label"
                          >Expected Travel Date<sup
                            class="ml-1 font-weight-bolder text-danger"
                            >*</sup
                          ></label
                        >
                        <input
                          type="text"
                          class="form-control"
                          id=""
                          readOnly
                          formControlName="travelDate"
                          placeholder=""
                        />
                      </div>
                      <div class="col-md-12 mt-3">
                        <label class="form-label"
                          >Preferred Test State<sup
                            class="ml-1 font-weight-bolder text-danger"
                            >*</sup
                          ></label
                        >
                        <input
                          type="text"
                          class="form-control"
                          maxlength="20"
                          id=""
                          formControlName="testState"
                          placeholder="Test State"
                          [ngClass]="{ 'is-invalid': submitted &amp;&amp; appointmentForm.controls.testState.errors }"
                        />

                        <div
                          *ngIf="submitted &amp;&amp; appointmentForm.controls.testState.errors"
                          class="form-text text-danger"
                        >
                          <div
                            *ngIf="
                              appointmentForm.controls.testState.errors.required
                            "
                          >
                            Test state is required
                          </div>
                          <div
                            *ngIf="
                              appointmentForm.controls.testState.errors.pattern
                            "
                          >
                            Must be only alphabets
                          </div>
                        </div>
                      </div>
                      <div class="col-md-12 mt-3">
                        <label class="form-label"
                          >Preferred Test LGA<sup
                            class="ml-1 font-weight-bolder text-danger"
                            >*</sup
                          ></label
                        >
                        <select
                          class="form-control"
                          id=""
                          formControlName="testLga"
                          placeholder="test LGA"
                          [ngClass]="{ 'is-invalid': submitted &amp;&amp; appointmentForm.controls.testLga.errors }"
                        >
                          <option value="">Select Preferred Test LGA</option>
                          <option
                            *ngFor="let lga of lgas"
                            value="{{ lga?.id }}"
                          >
                            {{ lga.name }} {{ lga?.lga_code }}
                          </option>
                        </select>
                        <div
                          *ngIf="submitted &amp;&amp; appointmentForm.controls.testLga.errors"
                          class="form-text text-danger"
                        >
                          <div
                            *ngIf="
                              appointmentForm.controls.testLga.errors.required
                            "
                          >
                            Test LGA is required
                          </div>
                        </div>
                      </div>

                      <div class="">
                        <div class="form-group pt-4 pl-3 pr-3">
                          <label class="form-label"
                            >Select Date<sup
                              class="ml-1 font-weight-bolder text-danger"
                              >*</sup
                            ></label
                          >
                          <input
                            type="date"
                            min="{{ date | date: 'yyyy-MM-dd' }}"
                            max="{{ travelDate | date: 'yyyy-MM-dd' }}"
                            formControlName="bookingDate"
                            class="form-control"
                            [ngClass]="{ 'is-invalid': submitted &amp;&amp; appointmentForm.controls.bookingDate.errors }"
                          />
                          <div
                            *ngIf="submitted &amp;&amp; appointmentForm.controls.bookingDate.errors"
                            class="form-text text-danger"
                          >
                            <div
                              *ngIf="
                                appointmentForm.controls.bookingDate.errors
                                  .required
                              "
                            >
                              Date is required
                            </div>
                          </div>
                        </div>

                        <div class="form-group pt-2 pl-3 pr-3">
                          <label class="form-label"
                            >Select Time<sup
                              class="ml-1 font-weight-bolder text-danger"
                              >*</sup
                            ></label
                          >
                          <input
                            type="time"
                            formControlName="bookingTime"
                            class="form-control"
                            [ngClass]="{ 'is-invalid': submitted &amp;&amp; appointmentForm.controls.bookingTime.errors }"
                          />
                          <div
                            *ngIf="submitted &amp;&amp; appointmentForm.controls.bookingTime.errors"
                            class="form-text text-danger"
                          >
                            <div
                              *ngIf="
                                appointmentForm.controls.bookingTime.errors
                                  .required
                              "
                            >
                              Time is required
                            </div>
                          </div>
                        </div>
                        <!-- <mbsc-datepicker [controls]="['calendar', 'time']" display="inline" min="2000-01-01T12:00" max="2050-01-01T12:00">
                                               </mbsc-datepicker> -->
                        <div class="ml-3 text-center">
                          <!-- <label>Confirm selected booking time and date</label><br> -->
                          <a
                            class="btn text-white mt-3"
                            style="background-color: rgb(30, 35, 125)"
                            (click)="confirmTimeSlot()"
                            >Check availability</a
                          >
                        </div>
                      </div>
                    </div>

                    <div class="col-lg-7 col-md-6 div-scroll-alert col-sm-12">
                      <h5 class="dashboard-heading-1 mt-5">
                        Select Test Center And Time
                      </h5>
                      <div
                        class=""
                        *ngFor="
                          let center of collectionCenters?.data;
                          index as i
                        "
                      >
                        <div
                          class="row mt-3 border-bottom-inbound"
                          [ngClass]="{ 'bg-center': centerId == center.id }"
                        >
                          <div class="col-md-8">
                            <h6 class="center-name">
                              {{ center?.name }}
                              <!-- <a href="#" class="map-btn">Show on map</a> -->
                            </h6>
                            <br />
                            <div class="center-address">
                              {{ center?.email }}<br />
                              {{ center?.address }}<br />
                              Phone: {{ center?.phone }}
                            </div>
                            <small
                              class="test-sm"
                              *ngFor="
                                let item of center?.working_days | keyvalue
                              "
                              >{{ item.key | titlecase }}:
                              {{
                                "2020-12-12T" + item.value?.opening_time
                                  | date: "h:mm a"
                              }}
                              -
                              {{
                                "2020-12-12T" + item.value?.closing
                                  | date: "h:mm a" + ", "
                              }}</small
                            >
                          </div>
                          <div class="col-md-4">
                            <h6 class="font-weight-bold">
                              CFA {{ center?.amount }}
                            </h6>
                            <button
                              type="button"
                              class="btn btn-primary theme-btn mt-3"
                              (click)="
                                centerId = center?.id;
                                centerName = center?.name;
                                centerAmount = center?.amount
                              "
                              [disabled]="centerId == center?.id"
                            >
                              Select
                            </button>
                          </div>
                        </div>
                      </div>
                      <hr />
                    </div>

                    <div class="col-md-12 mt-2 text-center mb-3 mt-5">
                      <button
                        type="button"
                        class="btn btn-primary theme-btn"
                        (click)="showPersonalInfo()"
                      >
                        <i class="fas fa-angle-double-left"></i> Back
                      </button>
                      <button
                        type="submit"
                        class="btn btn-primary theme-btn ml-3"
                      >
                        Next <i class="fas fa-angle-double-right"></i>
                      </button>
                    </div>
                  </div>
                </form>
              </div>

              <div
                class="col-lg-12 inbound-regi pb-5 font-13"
                *ngIf="confirmationTab"
              >
                <div
                  class="
                    col-lg-7 col-sm-12
                    mx-auto
                    card
                    shadow
                    col-md-4
                    confirmation-tab
                    p-5
                    mt-5
                  "
                >
                  <span class="text-success"
                    ><i class="fas fa-info-circle text-success"></i> Results
                    take 24hours from receipt of samples</span
                  >
                  <h4 class="font-weight-bolder mt-4">APPOINTMENT DETAILS</h4>
                  <div class="mt-3">
                    <div class="row mb-3">
                      <span class="col-md-6 font-weight-bolder"
                        >Full Name:</span
                      >
                      <span class="col-md-6">{{ fullName }}</span>
                    </div>
                    <div class="row mb-3">
                      <span class="col-md-6 font-weight-bolder"
                        >Passport Number:</span
                      >
                      <span class="col-md-6">{{ passportNumber }}</span>
                    </div>
                    <div class="row mb-3">
                      <span class="col-md-6 font-weight-bolder"
                        >Date Of Travel:</span
                      >
                      <span class="col-md-6">{{ travelDate }}</span>
                    </div>
                    <div class="row mb-3">
                      <span class="col-md-6 font-weight-bolder"
                        >Preferred Test Location:</span
                      >
                      <span class="col-md-6">{{
                        booking_info.prefer_state
                      }}</span>
                    </div>
                    <div class="row mb-3">
                      <span class="col-md-6 font-weight-bolder"
                        >Preferred Text Center:</span
                      >
                      <span class="col-md-6">{{ centerName }}</span>
                    </div>
                    <div class="row mb-3">
                      <span class="col-md-6 font-weight-bolder"
                        >Appointment Date</span
                      >
                      <span class="col-md-6">{{ appointment }}</span>
                    </div>
                  </div>

                  <div class="button text-center mt-4">
                    <button
                      type="button"
                      class="btn btn-primary theme-btn"
                      (click)="backBookAppointment()"
                    >
                      <i class="fas fa-angle-double-left"></i> Back
                    </button>
                    <button
                      type="button"
                      class="btn btn-primary theme-btn ml-3"
                      (click)="submitOutbound()"
                    >
                      Submit <i class="fas fa-angle-double-right"></i>
                    </button>
                  </div>
                </div>
              </div>

              <div class="col-lg-12 inbound-regi pb-5" *ngIf="paymentTab">
                <div class="mx-auto card shadow col-md-10 p-4 mt-5">
                  <h4 class="font-weight-bolder dashboard-heading-1">
                    PAYMENT DETAILS
                  </h4>

                  <!-- <form >
                                <div class="mt-4 form-row form-group">
                                   <label>Text Fee : </label>
                                   <input type="text" placeholder="CFA 1,200"  maxlength="20" class="form-control ">
                                </div>
                                <div class="mt-5 text-center">
                                   <button type="submit" class="btn btn-primary theme-btn ml-3" data-toggle="modal" data-target="#staticBackdrop">Pay </button>
                                </div>
           
                             </form> -->

                  <div class="row">
                    <div class="col-lg-4">
                      <div
                        class="nav flex-column nav-pills tabbing"
                        id="v-pills-tab"
                        role="tablist"
                        aria-orientation="vertical"
                      >
                        <a
                          class="nav-link tab-btn-design active"
                          id="v-pills-home-tab"
                          data-toggle="pill"
                          href="#tab_1"
                          role="tab"
                          aria-controls="tab_1"
                          aria-selected="true"
                          ><img src="assets/image/icon/icon-1.png" />
                          <span>Credit/Debit</span></a
                        >
                        <a
                          class="nav-link tab-btn-design"
                          id="v-pills-profile-tab"
                          data-toggle="pill"
                          href="#tab_2"
                          role="tab"
                          aria-controls="tab_2"
                          aria-selected="false"
                          ><img src="assets/image/icon/icon-2.png" />
                          <span>Mobile App</span></a
                        >
                        <a
                          class="nav-link tab-btn-design"
                          id="v-pills-messages-tab"
                          data-toggle="pill"
                          href="#tab_3"
                          role="tab"
                          aria-controls="tab_3"
                          aria-selected="false"
                          ><img src="assets/image/icon/icon-3.png" /><span>
                            Bank Branch
                          </span></a
                        >
                        <a
                          class="nav-link tab-btn-design"
                          id="v-pills-settings-tab"
                          data-toggle="pill"
                          href="#tab_4"
                          role="tab"
                          aria-controls="tab_4"
                          aria-selected="false"
                          ><img src="assets/image/icon/icon-4.png" /><span
                            >POS</span
                          ></a
                        >
                        <a
                          class="nav-link tab-btn-design"
                          id="v-pills-settings-tab"
                          data-toggle="pill"
                          href="#tab_5"
                          role="tab"
                          aria-controls="tab_5"
                          aria-selected="false"
                          ><img src="assets/image/icon/icon-5.png" /><span
                            >ATM</span
                          ></a
                        >
                      </div>
                    </div>
                    <div class="col-lg-8">
                      <div class="tab-content" id="v-pills-tabContent">
                        <!-- START CREDIT CARD PAYMENT PROCESSING -->
                        <div
                          class="tab-pane fade show active"
                          id="tab_1"
                          role="tabpanel"
                          aria-labelledby="tab_1"
                        >
                          <form
                            [formGroup]="paymentGatewayForm"
                            (ngSubmit)="onShowOTP(paymentGatewayForm.value)"
                          >
                            <div class="form-group">
                              <label for="inputAddress">Amount</label>
                              <input
                                type="text"
                                disabled
                                class="form-control card-number"
                                placeholder="CFA 838738"
                                formControlName="amount"
                              />

                              <div
                                *ngIf="submitted &amp;&amp; paymentGatewayForm.controls.amount.errors"
                                class="form-text text-danger"
                              >
                                <div
                                  *ngIf="
                                    paymentGatewayForm.controls.amount.errors
                                      .required
                                  "
                                >
                                  Amount is required
                                </div>
                                <div
                                  *ngIf="
                                    paymentGatewayForm.controls.amount.errors
                                      .pattern
                                  "
                                >
                                  Only numeric value reqiured
                                </div>
                                <div
                                  *ngIf="
                                    paymentGatewayForm.controls.amount.errors
                                      .minlength
                                  "
                                >
                                  Minimum of 1 digit required
                                </div>
                              </div>
                            </div>

                            <div class="form-group">
                              <label for="inputAddress">Card Number</label>
                              <input
                                type="text"
                                class="form-control card-number"
                                placeholder="Enter Your Card Number"
                                formControlName="cardNumber"
                              />

                              <div
                                *ngIf="submitted &amp;&amp; paymentGatewayForm.controls.cardNumber.errors"
                                class="form-text text-danger"
                              >
                                <div
                                  *ngIf="
                                    paymentGatewayForm.controls.cardNumber
                                      .errors.required
                                  "
                                >
                                  Card number is required
                                </div>
                                <div
                                  *ngIf="
                                    paymentGatewayForm.controls.cardNumber
                                      .errors.pattern
                                  "
                                >
                                  Only numeric value required
                                </div>
                                <div
                                  *ngIf="
                                    paymentGatewayForm.controls.cardNumber
                                      .errors.minlength
                                  "
                                >
                                  Minimum of 15 digit required
                                </div>
                              </div>
                            </div>

                            <div class="form-row">
                              <div class="form-group col-md-6">
                                <label for="inputEmail4">Expiry Date</label>

                                <div class="row card-valid">
                                  <div class="expiry-month">
                                    <select
                                      class="form-control"
                                      formControlName="expiryDateMonth"
                                    >
                                      <option selected>Month</option>
                                      <option>01</option>
                                      <option>02</option>
                                      <option>03</option>
                                      <option>04</option>
                                      <option>05</option>
                                      <option>06</option>
                                      <option>07</option>
                                      <option>08</option>
                                      <option>09</option>
                                      <option>10</option>
                                      <option>11</option>
                                      <option>12</option>
                                    </select>

                                    <div
                                      *ngIf="submitted &amp;&amp; paymentGatewayForm.controls.expiryDateMonth.errors"
                                      class="form-text text-danger"
                                    >
                                      <div
                                        *ngIf="
                                          paymentGatewayForm.controls
                                            .expiryDateMonth.errors.required
                                        "
                                      >
                                        Expiry month is required
                                      </div>
                                      <div
                                        *ngIf="
                                          paymentGatewayForm.controls
                                            .expiryDateMonth.errors.pattern
                                        "
                                      >
                                        Only numeric value required
                                      </div>
                                      <div
                                        *ngIf="
                                          paymentGatewayForm.controls
                                            .expiryDateMonth.errors.minlength
                                        "
                                      >
                                        Minimum of 2 digit required
                                      </div>
                                    </div>
                                  </div>
                                  <div class="expiry-year">
                                    <select
                                      class="form-control"
                                      formControlName="expiryDateYear"
                                    >
                                      <option selected>Year</option>
                                      <option>2021</option>
                                      <option>2022</option>
                                      <option>2023</option>
                                      <option>2024</option>
                                      <option>2025</option>
                                    </select>

                                    <div
                                      *ngIf="submitted &amp;&amp; paymentGatewayForm.controls.expiryDateYear.errors"
                                      class="form-text text-danger"
                                    >
                                      <div
                                        *ngIf="
                                          paymentGatewayForm.controls
                                            .expiryDateYear.errors.required
                                        "
                                      >
                                        Expiry year is required
                                      </div>
                                      <div
                                        *ngIf="
                                          paymentGatewayForm.controls
                                            .expiryDateYear.errors.pattern
                                        "
                                      >
                                        Only numeric value required
                                      </div>
                                      <div
                                        *ngIf="
                                          paymentGatewayForm.controls
                                            .expiryDateYear.errors.minlength
                                        "
                                      >
                                        Minimum of 4 digit required
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div class="form-group col-md-6">
                                <label for="inputPassword4">CVV Code</label>
                                <input
                                  type="password"
                                  class="form-control"
                                  placeholder="CVV"
                                  formControlName="ccvCode"
                                />

                                <div
                                  *ngIf="submitted &amp;&amp; paymentGatewayForm.controls.ccvCode.errors"
                                  class="form-text text-danger"
                                >
                                  <div
                                    *ngIf="
                                      paymentGatewayForm.controls.ccvCode.errors
                                        .required
                                    "
                                  >
                                    CCV code is required
                                  </div>
                                  <div
                                    *ngIf="
                                      paymentGatewayForm.controls.ccvCode.errors
                                        .pattern
                                    "
                                  >
                                    Only numeric value required
                                  </div>
                                  <div
                                    *ngIf="
                                      paymentGatewayForm.controls.ccvCode.errors
                                        .minlength
                                    "
                                  >
                                    Minimum of 3 digit required
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div class="form-group">
                              <label for="inputAddress">Card Holder</label>
                              <input
                                type="text"
                                class="form-control card-number"
                                id="inputAddress"
                                placeholder="Enter the card holder name"
                                formControlName="cardHolderName"
                              />

                              <div
                                *ngIf="submitted &amp;&amp; paymentGatewayForm.controls.cardHolderName.errors"
                                class="form-text text-danger"
                              >
                                <div
                                  *ngIf="
                                    paymentGatewayForm.controls.cardHolderName
                                      .errors.required
                                  "
                                >
                                  Card holder name is required
                                </div>
                                <div
                                  *ngIf="
                                    paymentGatewayForm.controls.cardHolderName
                                      .errors.pattern
                                  "
                                >
                                  Only alphabets value required
                                </div>
                              </div>
                            </div>

                            <div class="form-row">
                              <div
                                class="col-lg-5 form-check"
                                style="margin-left: 22px"
                              >
                                <input
                                  class="form-check-input margin-top-8"
                                  type="checkbox"
                                />
                                <label class="form-check-label" for="gridCheck">
                                  Save Card Details
                                </label>
                              </div>

                              <div
                                class="
                                  col-lg-6
                                  form-group
                                  payment-icon
                                  text-right
                                "
                              >
                                <img
                                  src="assets/image/payment-gateway-icon/american-express.png"
                                />
                                <img
                                  src="assets/image/payment-gateway-icon/mastercard.png"
                                />
                                <img
                                  src="assets/image/payment-gateway-icon/mestro.png"
                                />
                                <img
                                  src="assets/image/payment-gateway-icon/paypal2.png"
                                />
                              </div>
                            </div>

                            <div class="row">
                              <div class="col-lg-12 text-left mt-2">
                                <button type="submit" class="btn btn-primary">
                                  Make Payment
                                </button>
                                <button
                                  type="button"
                                  class="d-none"
                                  id="showOtpForm"
                                  data-toggle="modal"
                                  data-target="#staticBackdrop"
                                >
                                  showOtp
                                </button>
                              </div>
                            </div>
                          </form>
                        </div>
                        <!-- END CREDIT CARD PAYMENT PROCESSING -->

                        <div
                          class="tab-pane fade font-13"
                          id="tab_2"
                          role="tabpanel"
                          aria-labelledby="tab_2"
                        >
                          follow the steps below to make payments on your bank’s
                          mobile banking platform;<br />
                          - Login to your bank mobile application and select
                          transfer to bank.<br />
                          - Select ‘Parkway Readycash’ as the receiving bank and
                          input the your Bank3D Invoice Number (BIN) 1000148529
                          as the receiving bank account number<br />
                          - Enter the exact amount to pay in the ‘Amount to
                          transfer’ field that is ₦119,364.14 and proceed.<br />
                        </div>
                        <div
                          class="tab-pane fade font-13"
                          id="tab_3"
                          role="tabpanel"
                          aria-labelledby="tab_3"
                        >
                          Kindly walk into any of the underlisted banks and
                          present your Bank3D Invoice Number (BIN) to make
                          payment against this invoice
                        </div>
                        <div
                          class="tab-pane fade font-13"
                          id="tab_4"
                          role="tabpanel"
                          aria-labelledby="tab_4"
                        >
                          You can make payment at POS terminals in any of the
                          offices of the Nasarawa State Board of Internal
                          Revenue with your ATM cards (MasterCard, Visa and
                          Verve). You will be required to present your Bank3D
                          Invoice Number (BIN)
                        </div>
                        <div
                          class="tab-pane fade font-13"
                          id="tab_5"
                          role="tabpanel"
                          aria-labelledby="tab_5"
                        >
                          Follow the steps below to make payments at ATM;<br />

                          - Select the quickteller or bill pay option on the
                          ATM.<br />
                          - Select ‘Other Billers’ and enter biller number
                          ‘20057’ and input the your Bank3D Invoice Number (BIN)
                          1000148529 as the ‘Biller Reference Number’<br />
                          - Enter the exact amount to pay in the ‘Amount to
                          transfer’ field that is ₦119,364.14 and proceed.
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-lg-12 text-center mt-3">
                  <img src="assets/image/icon/muni.png" />
                  <p class="font-13">
                    Lorem Ipsum is simply dummy text of the printing and
                    typesetting industry. Lorem Ipsum is simply dummy text of
                    the printing and typesetting industry.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <!---------col-end---------->
        </div>
      </div>
    </div>
  </section>
  <app-footer></app-footer>
</main>

<!-- Modal -->
<div
  class="modal fade"
  id="staticBackdrop"
  data-backdrop="static"
  data-keyboard="false"
  tabindex="-1"
  aria-labelledby="staticBackdropLabel"
  aria-hidden="true"
>
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title"><strong> Enter the OTP </strong></h5>
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <!--  (ngSubmit)="onOtpSubmit(otpForm.value)" -->
      <form [formGroup]="otpForm" autocomplete="off">
        <div class="modal-body">
          <div class="form-group">
            <label for="inputAddress">Enter the OTP you have received.</label>
            <input
              type="password"
              class="form-control card-number pt-3 pb-3"
              id="inputAddress"
              placeholder="Enter OTP"
              formControlName="enterOtp"
              name="enterOtp"
              [ngClass]="{ 'is-invalid': submitted &amp;&amp; otpForm.controls.enterOtp.errors }"
            />

            <div
              *ngIf="submitted &amp;&amp; otpForm.controls.enterOtp.errors"
              class="form-text text-danger"
            >
              <div *ngIf="otpForm.controls.enterOtp.errors.required">
                OTP is required
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer text-center">
          <button
            type="button"
            class="btn btn-primary"
            data-dismiss="modal"
            aria-label="Close"
            (click)="onOtpSubmit(otpForm.value)"
          >
            Proceed
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
<!-- Modal -->
